<template>
  <WdsButtonGhost secondary :href="path" :title="column?.name ?? ''" class="tw-max-w-[310px]">
    <WdsStack class="job-po-number-column" direction-column>
      <WdsStack direction-row gap-xs align-center>
        <span>
          {{ column?.name ?? '' }}
        </span>
        <WdsTag v-if="column?.isBrief" xs subtle>{{ $t('Brief') }}</WdsTag>
      </WdsStack>
      <WdsText :sub-text="column?.purchaseOrderNumber ?? ''" />
    </WdsStack>
  </WdsButtonGhost>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsStack, WdsTag, WdsText } from '@worksome/wds-components'
import { graphql } from '@/gql'
import { $t } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { HireJobAndPoNumberColumnFragment, JobHireAndPoNumberColumnFragment } from '@/gql/graphql'

graphql(`
  fragment HireJobAndPoNumberColumn on Hire {
    id
    purchaseOrderNumber
    job {
      id
      number
      name
      isBrief
    }
    __typename
  }
`)

graphql(`
  fragment JobHireAndPoNumberColumn on Job {
    id
    number
    name
    isBrief
    __typename
  }
`)

const props = defineProps<{
  row: HireJobAndPoNumberColumnFragment | JobHireAndPoNumberColumnFragment
}>()
const column = computed(() => {
  if (!props.row) return null

  if (props.row.__typename === 'Hire') {
    return {
      purchaseOrderNumber: props.row.purchaseOrderNumber,
      number: props.row.job.number,
      name: props.row.job.name,
      id: props.row.job.id,
      isBrief: props.row.job.isBrief ?? false,
    }
  } if (props.row.__typename === 'Job') {
    return {
      purchaseOrderNumber: '',
      number: props.row.number,
      name: props.row.name,
      id: props.row.id,
      isBrief: props.row.isBrief ?? false,
    }
  }

  return null
})

const path = computed(() =>
  laravelNamedRoute(namedRoutes.jobs.show, { job: column.value?.id ?? '' }),
)
</script>

<style lang="scss">
.job-po-number-column {
  max-width: 300px;
  span,
  .wds-text-secondary {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
